export const COMMON_NAMESPACES: Record<string, string> = {
  dawgt: 'http://www.w3.org/2001/sw/DataAccess/tests/test-dawg#',
  dbpedia: 'http://dbpedia.org/resource/',
  dbpprop: 'http://dbpedia.org/property/',
  dc: 'http://purl.org/dc/elements/1.1/',
  dcat: 'http://www.w3.org/ns/dcat#',
  ebi: 'http://www.ebi.ac.uk/efo/',
  fn: 'http://www.w3.org/2005/xpath-functions/#',
  foaf: 'http://xmlns.com/foaf/0.1/',
  geo: 'http://www.w3.org/2003/01/geo/wgs84_pos#',
  go: 'http://purl.org/obo/owl/GO#',
  good: 'http://purl.org/goodrelations/v1#',
  HOOM: 'http://www.semanticweb.org/ontology/HOOM',
  ldp: 'http://www.w3.org/ns/ldp#',
  // from our prompt
  m: 'urn:stardog:modules:',
  math: 'http://www.w3.org/2000/10/swap/math#',
  mesh: 'http://purl.org/commons/record/mesh/',
  mf: 'http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#',
  nci: 'http://ncicb.nci.nih.gov/xml/owl/EVS/Thesaurus.owl#',
  obo: 'http://www.geneontology.org/formats/oboInOwl#',
  ogc: 'http://www.opengis.net/',
  ogcgml: 'http://www.opengis.net/ont/gml#',
  ogcgs: 'http://www.opengis.net/ont/geosparql#',
  ogcgsf: 'http://www.opengis.net/def/function/geosparql/',
  ogcgsr: 'http://www.opengis.net/def/rule/geosparql/',
  ogcsf: 'http://www.opengis.net/ont/sf#',
  ORDO: 'http://www.orpha.net/ORDO/',
  Orphanet_: 'http://www.orpha.net/ORDO/Orphanet_#',
  owl: 'http://www.w3.org/2002/07/owl#',
  product: 'http://www.buy.com/rss/module/productV2/',
  protseq: 'http://purl.org/science/protein/bysequence/',
  prov: 'http://www.w3.org/ns/prov#',
  rdf: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
  rdfa: 'http://www.w3.org/ns/rdfa#',
  rdfdf: 'http://www.openlinksw.com/virtrdf-data-formats#',
  rdfs: 'http://www.w3.org/2000/01/rdf-schema#',
  sc: 'http://purl.org/science/owl/sciencecommons/',
  scovo: 'http://purl.org/NET/scovo#',
  sd: 'http://www.w3.org/ns/sparql-service-description#',
  sh: 'http://www.w3.org/ns/shacl#',
  sioc: 'http://rdfs.org/sioc/ns#',
  skos: 'http://www.w3.org/2004/02/skos/core#',
  so: 'https://schema.org/',
  vcard: 'http://www.w3.org/2006/vcard/ns#',
  virtcxml: 'http://www.openlinksw.com/schemas/virtcxml#',
  virtrdf: 'http://www.openlinksw.com/schemas/virtrdf#',
  void: 'http://rdfs.org/ns/void#',
  xf: 'http://www.w3.org/2004/07/xpath-functions',
  xml: 'http://www.w3.org/XML/1998/namespace',
  xsd: 'http://www.w3.org/2001/XMLSchema#',
  // xsl10: 'http://www.w3.org/XSL/Transform/1.0',
  // xsl1999: 'http://www.w3.org/1999/XSL/Transform',
  // xslwd: 'http://www.w3.org/TR/WD-xsl',
  yago: 'http://dbpedia.org/class/yago/',
};
